// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import { MDBIcon, MDBCol, MDBRow } from 'mdbreact';
import workOrderStatusControl from '../../../../utils/workOrderStatusControl';
import { localCurrencySettings } from '../../../../utils/constans';
import ContractorRating from '../../ContractorRating';
import ContractorCertificatesChecks from '../../ContractorCertificatesChecks';
import AllRequestedWorkView from './AllRequestedWorkView';
import ContractorPreferedGroupsChecks from '../../PreferedGroupsCheck';

const ApplicantCard = ({
                           contractorInfo,
                           setCurrentApplicants,
                           toggleModal,
                           currentWorkOrder,
                           assignContractor,
                           userType,
                       }) => {
    const [isShowAllWork, setIsShowAllWork] = useState(false);
    const [selectedApplies, setSelectedApplies] = useState([contractorInfo.work_order_id]);

    const workOrderControlByStatus = currentWorkOrder?.status
        ? workOrderStatusControl(currentWorkOrder.status)
        : {};

    const handleAllWorkOrderReqView = () => {
        if (isShowAllWork) setSelectedApplies([contractorInfo.work_order_id]);
        setIsShowAllWork(!isShowAllWork);
    };

    return (
        <>
            <tr className="line_blocks">
                <td className="deployment_section">
                    <div className="page_row">
                        {/* === Contractor Basic Info === */}
                        <div className="right_col">
                            <div
                                className="block_label clickable"
                                onClick={() => {
                                    toggleModal(true, 'contractorDetailsModal', true, {
                                        contractorId: contractorInfo.contractor_details.userId,
                                    });
                                }}
                            >
                                {`${contractorInfo.contractor_details.name} - ${contractorInfo.contractor_details.unique_id}`}
                            </div>

                            <div className="info_block">
                                <div>{contractorInfo.contractor_details?.address}</div>
                                <div>
                                    {contractorInfo.contractor_details?.city?.label
                                        ? `${contractorInfo.contractor_details?.city?.label}, `
                                        : ''}
                                    {contractorInfo.contractor_details?.state?.label
                                        ? `${contractorInfo.contractor_details?.state?.label} `
                                        : ''}
                                    {contractorInfo.contractor_details?.zipcode || ''}
                                </div>
                            </div>
                        </div>

                        {/* === Pay Information === */}
                        <div className="left_col">
                            <div className="block_label">
                                {`Base Pay: ${(+contractorInfo.bidAmountBase).toLocaleString(
                                    'en-US',
                                    localCurrencySettings
                                )} / ${contractorInfo.basicType || currentWorkOrder.basicType}`}
                                <br />
                                {`Variable Pay: ${(+contractorInfo.bidAmountVariable || 0).toLocaleString(
                                    'en-US',
                                    localCurrencySettings
                                )} / ${currentWorkOrder.variableType}`}
                            </div>

                            <div className="info_block">
                                {contractorInfo?.startDate && (
                                    <span>
                                        Start Date:{' '}
                                        <span>
                                            {new Date(contractorInfo.startDate).toLocaleDateString('en-US')}
                                        </span>
                                    </span>
                                )}
                                {contractorInfo?.startTime && (
                                    <span style={{ marginLeft: '10px' }}>
                                        Start Time:
                                            <span>{contractorInfo.startTime || ''}</span>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* === Info List === */}
                    <ul className="info_list">
                        {contractorInfo.amountExpense || contractorInfo.descriptionExpense || contractorInfo.comment ? (
                            <li
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '6px',
                                    marginBottom: '12px',
                                }}
                            >
                                <span style={{ fontWeight: '700', fontSize: '15px' }}>Travel Expenses:</span>

                                {contractorInfo.amountExpense && (
                                    <span style={{color: '#0484bb', fontWeight: '600'}}>
          <strong>Amount:</strong>{' '}
                                        {(+contractorInfo.amountExpense).toLocaleString('en-US', localCurrencySettings)}
        </span>
                                )}

                                {contractorInfo.descriptionExpense && (
                                    <>
                                        <span style={{ fontWeight: '600' }}>Travel Expense Description:</span>
                                        <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {contractorInfo.descriptionExpense}
          </span>
                                    </>
                                )}
                            </li>
                        ) : null}

                        {contractorInfo.comment && (
                            <li
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '4px',
                                    marginBottom: '8px',
                                }}
                            >
                                <span style={{ fontWeight: '600' }}>Comment</span>
                                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {contractorInfo.comment}
    </span>
                            </li>
                        )}

                        <li>
                            <span style={{ display: 'block', fontWeight: '600' }}>Phone</span>
                            <span>
            <a href={`tel:${contractorInfo.contractor_details.phone}`}>
                {contractorInfo.contractor_details.phone}
            </a>
        </span>
                        </li>

                        <li>
                            <span  style={{ display: 'block', fontWeight: '600' }}>Email</span>
                            <span>
            <a href={`mailto:${contractorInfo.contractor_details.email}`}>
                {contractorInfo.contractor_details.email}
            </a>
        </span>
                        </li>
                    </ul>

                    {/* === Groups & Certificates === */}
                    <MDBRow>
                        <MDBCol>
                            {contractorInfo.contractor_details.groups?.length ? (
                                <ContractorPreferedGroupsChecks />
                            ) : null}
                        </MDBCol>
                        <MDBCol>
                            <ContractorCertificatesChecks
                                certificates={contractorInfo.contractor_details.certificates}
                                textAlign="center"
                            />
                        </MDBCol>
                    </MDBRow>

                    {/* === Rating === */}
                    <ContractorRating contractor={contractorInfo.contractor_details} />

                    {/* === Actions === */}
                    <div className="profile_actions">
                        {userType === 'client' && (
                            <>
                                {workOrderControlByStatus.beforeAssigned &&
                                !workOrderControlByStatus.canceled ? (
                                    Object.values(contractorInfo.block).some((el) => el) ? (
                                        <button
                                            className="standard_btn light_btn"
                                            onClick={() => {
                                                toggleModal(true, 'blockModal', false, {
                                                    contractorId: contractorInfo.contractor_id,
                                                });
                                            }}
                                        >
                                            Blocked
                                        </button>
                                    ) : (
                                        <button
                                            className="standard_btn dark_btn"
                                            disabled={contractorInfo.status === 'withdrawn'}
                                            onClick={() => {
                                                if (contractorInfo.status !== 'withdrawn') {
                                                    assignContractor(
                                                        { workOrdersId: selectedApplies },
                                                        contractorInfo.contractor_id
                                                    );
                                                }
                                            }}
                                        >
                                            {contractorInfo.status === 'withdrawn' ? 'Withdrawn' : 'Assign'}
                                        </button>
                                    )
                                ) : null}

                                {!['apply', 'archived'].includes(contractorInfo.status) && (
                                    <>
                                        <button className="standard_btn light_btn">Assigned</button>
                                        {!currentWorkOrder?.checkInOutDetails?.length && (
                                            <button
                                                className="standard_btn dark_btn"
                                                onClick={() => {
                                                    toggleModal(true, 'unAssignModal', true, {
                                                        workOrdersId: [currentWorkOrder._id],
                                                    });
                                                    setCurrentApplicants(contractorInfo);
                                                }}
                                            >
                                                Un-assign
                                            </button>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </td>
            </tr>

            {/* === All Requested Work === */}
            <AllRequestedWorkView
                isShowAllWork={isShowAllWork}
                contractor={contractorInfo}
                selectedApplies={selectedApplies}
                selectApplies={setSelectedApplies}
            />
        </>
    );
};

export default ApplicantCard;
